export const asUtc = (date?: Date) => {
  if (!date) {
    return undefined;
  }
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

export const toUtc = (date?: Date): Date | undefined => {
  if (!date) {
    return undefined;
  }
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
};
